export const Resources = {
  pinnedFieldsCount: (count: number) => `+${count} ${count === 1 ? 'field' : 'fields'}`,
}
